import { Alert, Typography } from '@mui/material';
import React, { useEffect } from 'react';

import { useSupportPhoneDisplay } from '../utils';
import { getAppTitle, getSerialMissingError } from '../utils/constants';

import { PageLayout, RedirectPage } from '.';

interface QRRedirectLayoutProps {
  serial?: string;
  redirectUrl?: string | null;
  shouldRedirectToSession?: boolean;
}

/**
 * Reusable layout for QR redirect pages
 * Handles common states: missing serial, loading, and redirect
 */
export const QRRedirectLayout: React.FC<QRRedirectLayoutProps> = ({
  serial,
  redirectUrl,
  shouldRedirectToSession = false,
}) => {
  const supportPhoneDisplay = useSupportPhoneDisplay();

  useEffect(() => {
    if (shouldRedirectToSession) {
      window.location.href = '/session';
    }
  }, [shouldRedirectToSession]);

  if (!serial) {
    return (
      <PageLayout>
        <Typography variant="h1" component="h1" gutterBottom>
          {getAppTitle()}
        </Typography>
        <Alert severity="error">
          {getSerialMissingError(supportPhoneDisplay)}
        </Alert>
      </PageLayout>
    );
  }

  if (shouldRedirectToSession) {
    return null;
  }

  if (redirectUrl) {
    return <RedirectPage serial={serial} redirectUrl={redirectUrl} />;
  }

  // Show loading state
  return <RedirectPage serial={serial} redirectUrl="" />;
};
